import {useIntl} from 'react-intl'
import {useRemoveCart} from '../context/useMutation'
import {useGetBasket} from '../context/useQuery'
import {useMarket} from '../hook'

export default function MarketPlace() {
  const intl = useIntl()
  const {refetch} = useGetBasket()
  const {basket, basketId} = useMarket()
  const {mutateAsync: mutateRemove} = useRemoveCart()

  const removeItem = async (basketItemId: string) => {
    await mutateRemove({basketItemId: basketItemId, basketId, count: 0})
    refetch()
  }

  const discount = 0

  return (
    <div className='card card-custom gutter-b'>
      <div className='card-header flex-wrap border-0 pt-6 pb-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label font-weight-bolder font-size-h3 text-dark'>
            {intl.formatMessage({id: 'MARKET.CART'})}({basket?.basketItemList.length || 0})
          </span>
        </h3>
        <div className='card-toolbar'>
          <div className='dropdown dropdown-inline'>
            <a href='/market-place' className='btn btn-primary font-weight-bolder font-size-sm'>
              {intl.formatMessage({id: 'MARKET.CART.CONTINUE'})}
            </a>
          </div>
        </div>
      </div>

      <div className='card-body'>
        {basket?.basketItemList.length === 0 ? (
          <div className='d-flex align-items-center justify-content-center flex-column py-20'>
            <h3 className='font-weight-bolder font-size-h1 mb-10'>No product found</h3>
          </div>
        ) : (
          <div className='table-responsive'>
            <table className='table table-bordered'>
              <thead>
                <tr className='border-0'>
                  <th>{intl.formatMessage({id: 'MARKET.CART.PRODUCT_NAME'})}</th>
                  <th className='text-center'>
                    {intl.formatMessage({id: 'MARKET.CART.QUANTITY'})}
                  </th>
                  <th className='text-right'>{intl.formatMessage({id: 'MARKET.CART.PRICE'})}</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {basket?.basketItemList.map((item, index) => (
                  <tr key={index}>
                    <td className='d-flex align-items-center font-weight-bolder'>
                      <div className='symbol symbol-60 flex-shrink-0 mr-4 bg-light'>
                        <img src={item.product.image} alt='' style={{maxHeight: '50px'}} />
                      </div>
                      <a
                        href={`/market-place/${item.product.id}`}
                        style={{marginLeft: 10}}
                        className='text-dark text-hover-primary'
                      >
                        {item.product.name}
                      </a>
                    </td>
                    <td className='text-center align-middle'>1</td>
                    {/* <td className="text-center align-middle">
                      <button
                        className="btn btn-xs btn-light-success btn-icon mr-2"
                        onClick={() => updateItemQuantity(item.id, (item.quantity || 1) - 1)}
                      >
                        <i className="bi bi-dash icon-lg"></i>
                      </button>
                      <span className="mr-2 font-weight-bolder">
                        {item.count}
                      </span>
                      <button
                        className="btn btn-xs btn-light-success btn-icon"
                        // onClick={() => updateItemQuantity(item.id, (item.count || 1) + 1)}
                      >
                        <i className="bi bi-plus icon-xl"></i>
                      </button>
                    </td> */}
                    <td className='text-right align-middle font-weight-bolder font-size-h5'>
                      {item.product.price}AED
                    </td>
                    <td className='text-right'>
                      <button
                        className='btn btn-danger font-weight-bolder font-size-sm ml-auto'
                        onClick={() => removeItem(item.basketItemId)}
                      >
                        {intl.formatMessage({id: 'MARKET.CART.REMOVE'})}
                      </button>
                    </td>
                  </tr>
                ))}

                <tr className='border-0'>
                  <td colSpan={2}></td>
                  <td className='font-weight-bolder text-right'>
                    {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.SUBTOTAL'})}
                  </td>
                  <td className='font-weight-bolder text-right pr-0'>AED{basket?.totalPrice}</td>
                </tr>
                <tr className='border-0'>
                  <td colSpan={2} className='border-0 pt-0'></td>
                  <td className='border-0 pt-0 font-weight-bolder text-right'>
                    {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.DISCOUNT'})}
                  </td>
                  <td className='border-0 pt-0 font-weight-bolder text-right pr-0'>
                    AED{discount}
                  </td>
                </tr>
                <tr className='border-0'>
                  <td colSpan={2} className='border-0 pt-0'></td>
                  <td className='border-0 pt-0 font-weight-bolder font-size-h5 text-right'>
                    {intl.formatMessage({id: 'CHECKOUT.PURCHASE.TABLE.TOTAL'})}
                  </td>
                  <td className='border-0 pt-0 font-weight-bolder font-size-h5 text-success text-right pr-0'>
                    AED{(basket?.totalPrice || 0) + discount}
                  </td>
                </tr>

                <tr className='border-0'>
                  <td colSpan={4} className='border-0 text-right pt-10'>
                    <a
                      href='/market-place/checkout'
                      className='btn btn-success font-weight-bolder px-8'
                    >
                      {intl.formatMessage({id: 'MARKET.CART.PROCCED'})}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
